import { Hint, IFilter } from "../api";

export function parseQuery(queryString: string) {
  var query: Record<string, string> = {};
  var pairs = (queryString[0] === '?' ? queryString.substring(1) : queryString).split('&');
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}

export const queryFromFilters = (filters: IFilter[]) => {
  var res: string[] = [];

  for (var f of filters) {
    if (!f.hint) {

      if (f.value) {
        res.push(`s=${encodeURIComponent(`${f.value}:${f.label}`)}`);
      }
    }
    else {
      res.push(`${f.hint}=${encodeURIComponent(`${f.value}:${f.label}`)}`);
    }
  }
  return res.join('&');
}

export const queryToFilters = (qs: string) => {
  const res: IFilter[] = []
  var pairs = (qs[0] === '?' ? qs.substring(1) : qs).split('&').filter(r => r ? true : false);
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    if (pair.length != 2) {
      continue;
    }
    var hint = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    var index = value.indexOf(':');
    res.push({
      value: index >= 0 ? value.substring(0, index) : value,
      label: index >= 0 ? value.substring(index + 1) : value,
      hint: hint == "s" ? undefined : hint as Hint
    });
  }
  return res;
}